"use client";

import React from "react";
import { Home, MapPin, Mail, Users, Search, Smartphone } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";

/**
 * RealEstateWebsite — Section 4: 6 Branchen-Features
 * Drop-in für: src/pages/RealEstateWebsite/sections/Services.tsx
 */

const features = [{
  icon: Home,
  title: "Objekt-Galerie",
  description: "Präsentieren Sie Ihre Immobilien mit Bildergalerien, Grundrissen und allen wichtigen Details — übersichtlich und professionell."
}, {
  icon: MapPin,
  title: "Standort-Karten",
  description: "Zeigen Sie die Lage jedes Objekts auf Google Maps. Interessenten sehen sofort die Umgebung und Infrastruktur."
}, {
  icon: Mail,
  title: "Anfrage-Formular",
  description: "Interessenten melden sich direkt über Ihr Formular — mit Angabe zum gewünschten Objekt. Sie erhalten qualifizierte Leads."
}, {
  icon: Users,
  title: "Über uns / Team",
  description: "Stellen Sie Ihr Team vor. Vertrauen entsteht durch Gesichter — zeigen Sie, wer hinter Ihrem Büro steht."
}, {
  icon: Search,
  title: "Lokale SEO",
  description: 'Lokale SEO für „Immobilien Zürich" oder „Wohnung mieten Bern" — die KI optimiert Ihre Website für lokale Google-Suchanfragen.'
}, {
  icon: Smartphone,
  title: "Mobilfreundlich",
  description: "Interessenten browsen unterwegs. Ihre Website sieht auf Smartphone, Tablet und Desktop perfekt aus."
}];
export default function Services() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="bg-background py-20 md:py-24">
      <div ref={ref} className={`max-w-7xl mx-auto px-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center max-w-3xl mx-auto mb-14 md:mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4 leading-tight">
            Ihre Immobilien-Website, komplett ausgestattet
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground">
            Alles für Makler und Immobilienbüros.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, i) => <div key={i} className="group bg-card border border-border rounded-xl p-7 hover:border-primary/40 hover:shadow-xl transition-all duration-300">
              <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-white transition-colors">
                <f.icon className="w-6 h-6" strokeWidth={1.5} />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-2 tracking-tight">
                {f.title}
              </h3>
              <p className="text-base leading-relaxed text-muted-foreground">
                {f.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}